 <template>
    <div class="recognize-fj"> 
        <div class="recognize-info">
            <p class="description">方剂识别功能主要用于辅助广大中医学者及研究 人员更好地学习经典名方在临床中的实际应用，在输入框中输入中药组成，并且使用顿号、逗号、句号等符号将各个中药分开，点击下方识别按钮，结果将展示与输入中药组成相似的经典名方和8w条来自方剂大辞典中的方剂。并可查看方剂详情。</p>
            <div  v-if='!isShowList'  class="serch-textarea">
                <el-input
                    :autosize="{ minRows: 8, maxRows: 20}"
                    type="textarea" 
                    placeholder="请输入内容"
                    v-model.trim="keyword"
                />
                <div class="textarea-btn">
                    <el-button type="primary" @click="recognize_click">识别</el-button>
                    <el-button type="danger" plain @click="reset_click">清空</el-button>
                </div>
            </div>
            <recognizeList v-else :keyword.sync='keyword' ></recognizeList>
        </div>
    </div>
</template>

<script>
import recognizeList from './recognize_list.vue'
export default {
    components: {
        recognizeList,
    },
    data () {
        return {
            keyword:'柴胡,赤芍,甘草,半夏,黄芩,人参,生姜,大枣',
            isShowList:false, 
        }
    }, 
    methods: {
        recognize_click(){
            if(this.keyword==''){
                this.$message.error( '请输入相关中药名称～')
                return
            }
            this.isShowList = true;
        },
        reset_click(){
            this.keyword = '';
        },
    }
}
</script>

<style lang="less" scoped>
.recognize-fj{
    input,textarea{
        border: none;
        border: 1px solid rgba(184, 151, 122, 1);
    }
    min-width: 1200px;
    // background: url(../../assets/images/wlylx_title_bg.jpg) top center no-repeat,url(../../assets/images/wlylx_container_bg.jpg);
    background-size: contain;
    padding-bottom: 30px;
    .recognize-title{
        // background: url("../../assets/images/fj_title.png") no-repeat center;
		height: 24px;
		margin: 0 auto;
		padding: 60px 0;
    }
    .recognize-info{
        width: 1200px;
        margin: 0 auto; 
        // background: #F9F6F2;
        // box-shadow: 0px 3px 12px 0px #c4bfbc;
        box-sizing: border-box;
        padding: 30px; 
        .description{
            text-indent: 2em;
            font-size: 16px;
            line-height: 28px;
            margin-bottom: 34px;
        }
        .serch-textarea{ 
            width: 100%; 
            margin: 20px auto;
            // background: rgba(250, 248, 247, 1);
            border-radius: 4px;  
            color: #4c4c4c;
            textarea{
                padding: 12px 20px;
            }
            .textarea-btn{
                margin-top: 30px;
                text-align: center;
            }
        }
    }
}
</style>